import { COLOR } from '@/libs/core/constants'
import { pixelToDxa } from '@/libs/utils/docxUtils'
import {
  AlignmentType,
  BorderStyle,
  PageBreak,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
  HeadingLevel,
} from 'docx'
import SectionHeader from '../../SectionHeader'
import { tableIndentedWidthDxa, tableWidthDxa1050 } from '../../constants'
import {
  parseDateToTaiwanDateSlash,
  calculateDateRangeDays,
} from '../../../ReportPDF/TaiwanDateConvert'

const getCellProps = ({ color, value, children }) => ({
  margins: { top: 60, bottom: 60, left: 90, right: 90 },
  verticalAlign: VerticalAlign.CENTER,
  shading: { fill: color },
  children: children || [new Paragraph({ children: value, alignment: AlignmentType.CENTER })],
})

const Row = ({ first = [], second = [], third = [], color = 'FFFFFF' }) =>
  new TableRow({
    height: { value: pixelToDxa(40) },
    children: [
      new TableCell({
        ...getCellProps({ color, children: first }),
        borders: {
          top: { size: 0.6, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          right: { size: 0, style: BorderStyle.NONE, color },
          left: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          bottom: { size: 0.6, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
        },
      }),
      new TableCell({
        ...getCellProps({ color, children: second }),
        borders: {
          top: { size: 0.6, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          right: { size: 0, style: BorderStyle.NONE, color },
          left: { size: 0, style: BorderStyle.NONE, color },
          bottom: { size: 0.6, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
        },
      }),
      new TableCell({
        ...getCellProps({ color, children: third }),
        borders: {
          top: { size: 0.6, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          right: { size: 1, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
          left: { size: 0, style: BorderStyle.NONE, color },
          bottom: { size: 0.6, style: BorderStyle.SINGLE, color: COLOR.secondary_120 },
        },
      }),
    ],
  })

const Row2 = ({ first = [], second = [], third = [], color = 'FFFFFF' }) =>
  new TableRow({
    height: { value: pixelToDxa(40) },
    children: [
      new TableCell({
        ...getCellProps({ color, children: first }),
      }),
      new TableCell({
        ...getCellProps({ color, children: second }),
      }),
      new TableCell({
        ...getCellProps({ color, children: third }),
      }),
    ],
  })

const Chapter3Page = ({ reportData }) => {
  const { reprotDao, phishType, secondaryCompanyNickname, generateStartDate, generateEndDate } =
    reportData || {}
  const { companyName, campaignStartDate, campaignEndDate, campaignDays } = reprotDao || {}
  const service = phishType

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph(''),
    SectionHeader({
      text: '第三章 介紹',
      size: 52,
      headingNumber: HeadingLevel.HEADING_1,
    }),
    new Paragraph({
      border: {
        top: {
          color: '#000000',
          style: BorderStyle.SINGLE,
          size: 25, // 控制橫線的粗細
        },
      },
    }),
    SectionHeader({
      text: '3.1 專案流程',
      size: 48,
      headingNumber: HeadingLevel.HEADING_2,
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: secondaryCompanyNickname,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '協助',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: companyName,

          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '檢視現有社交工程安全防護，並找出潛在危機，執行項目時程如下：',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),

    new Paragraph(''),

    new Table({
      // indent: { size: pixelToDxa(10), type: WidthType.DXA },
      columnWidths: [
        tableIndentedWidthDxa / 3,
        tableIndentedWidthDxa / 3,
        tableIndentedWidthDxa / 3,
      ],
      width: { size: tableIndentedWidthDxa, type: WidthType.DXA },
      rows: [
        Row({
          first: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '工作項目',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          second: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '工期',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          third: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '執行日期',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          color: '#a2badb',
        }),
        Row({
          first: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: `${service === '郵件' ? '電子' : ''}${service}${'社交工程檢測'}`,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          second: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: `${campaignDays}`,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: '日',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          third: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: `${parseDateToTaiwanDateSlash(
                    campaignStartDate,
                  )}至${parseDateToTaiwanDateSlash(campaignEndDate)}`,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          color: COLOR.secondary_60,
        }),
        Row({
          first: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '製作檢測報告書',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          second: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: `${calculateDateRangeDays(generateStartDate, generateEndDate)}`,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: '日',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          third: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: `${parseDateToTaiwanDateSlash(
                    generateStartDate,
                  )}至${parseDateToTaiwanDateSlash(generateEndDate)}`,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
        }),
      ],
    }),

    new Paragraph(''),

    SectionHeader({
      text: '3.2 專案執行項目',
      size: 48,
      headingNumber: HeadingLevel.HEADING_2,
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '\t',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '社交工程',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: service,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
        new TextRun({
          text: '測試服務建議執行之項目如下：',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph(''),
    new Table({
      // indent: { size: pixelToDxa(10), type: WidthType.DXA },
      // columnWidths: [pixelToDxa(300), pixelToDxa(500), tableIndentedWidthDxa - pixelToDxa(800)],
      columnWidths: [tableWidthDxa1050 / 3, tableWidthDxa1050 / 3, tableWidthDxa1050 / 3],
      width: { size: tableWidthDxa1050, type: WidthType.DXA },
      rows: [
        Row2({
          first: [
            new Paragraph({
              children: [
                new TextRun({
                  text: '項次',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          second: [
            new Paragraph({
              children: [
                new TextRun({
                  text: '項目',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          third: [
            new Paragraph({
              children: [
                new TextRun({
                  text: '內容說明',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
        }),
        Row2({
          first: [
            new Paragraph({
              children: [
                new TextRun({
                  text: '1',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          second: [
            new Paragraph({
              children: [
                new TextRun({
                  text: '測試內容',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],

          third: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '• ',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                  bold: true,
                }),
                new TextRun({
                  text: '郵件內容設計可涵蓋不同類型，供受測機關隨機挑選進行測試。',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
            }),
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '• ',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                  bold: true,
                }),
                new TextRun({
                  text: '測試系統將即時記錄受測信箱之、',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: '「瀏覽郵件」、「點閱連結」、「開',

                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  break: 1,
                  text: '   啟附件」及「輸入資料」',

                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: '等行為。',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
            }),
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '• ',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                  bold: true,
                }),
                new TextRun({
                  text: '測試系統可自動偽造寄件人信箱寄送測試信，大幅增加測試有效',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  break: 1,
                  text: '   率。例如：系統偽造受測人的同事、主管或大型入口網站、電子商務網',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  break: 1,
                  text: '   站的信箱地址寄出測試釣魚信件。',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
            }),
          ],
        }),
        Row2({
          first: [
            new Paragraph({
              children: [
                new TextRun({
                  text: '2',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          second: [
            new Paragraph({
              children: [
                new TextRun({
                  text: '分析報告',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          third: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '• ',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                  bold: true,
                }),
                new TextRun({
                  text: '整體結果統計圖表。',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
            }),
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '• ',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                  bold: true,
                }),
                new TextRun({
                  text: '統計',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: '「瀏覽郵件」、「點閱連結」、「開啟附件」及「輸入資料」等',

                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  break: 1,
                  text: '   受測者行為。',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
            }),
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '• ',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                  bold: true,
                }),
                new TextRun({
                  text: '統計「瀏覽郵件率」與「連結點閱率」、「開啟附件率」',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  break: 1,
                  text: '   及「輸入資料率」',

                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: '等結果圖表。',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
            }),
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '• ',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                  bold: true,
                }),
                new TextRun({
                  text: '個別受測者瀏覽及點閱等行為細部時間行為列表。',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
            }),
          ],
        }),

        Row2({
          first: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '3',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          second: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '諮詢服務',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
              alignment: AlignmentType.CENTER,
            }),
          ],
          third: [
            new Paragraph({
              style: 'textParagraph',
              children: [
                new TextRun({
                  text: '• ',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                  bold: true,
                }),
                new TextRun({
                  text: '分析報告提出後提供相關',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: '諮詢服務',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: '• ',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                  bold: true,
                }),
                new TextRun({
                  text: '資安諮詢服務團隊皆擁有',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: 'CEH',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: '或',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: 'CISSP',
                  bold: true,
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
                new TextRun({
                  text: '等國際資安證照。',
                  font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
                  size: 24,
                }),
              ],
            }),
          ],
        }),
      ],
    }),
  ]
}

export default Chapter3Page
